<app-video-player (durationVideoTime) = "durationVideoTime($event)" *ngIf="isSlowMotionGraphicsLoading" [first_video]='first_video' [second_video]='second_video' [event_id]='event_id'></app-video-player>
<app-spotlight-full-page-loader *ngIf="isLoading" [page]='page'></app-spotlight-full-page-loader>
<div *ngIf="!isSlowMotionGraphicsLoading && !isLoading" class="main_div is-loading-div">
    <div class="red-carpet-background" >
        <div class="row justify-content-center red-carpet-theater-background">
            <span class="welcome-message text-center">WELCOME {{firstName}}</span>
        </div>

        <!--Profile View-->
        <div class="red-carpet" style="width: 100%;" *ngIf="cinejoyFeaturedGuests" >
            <div fxLayout="row">
                <div class="col-3">
                    <img class="avatar" src="assets/images/spotlight/avatar_10.svg" style="margin-top: 0px;">
                    <img class="avatar" src="assets/images/spotlight/avatar_7.svg" style="margin: 10px 0 0px -50px;">
                </div>
                <div class="col-9" >
                    <div fxLayout="row"class="justify-content-center profile-thumb-view">
                        <div style="margin-top: 20px;" *ngIf="!isWatchStarted && cinejoyFeaturedGuests">
                            <img class="profile-thumb profile-thumb-one " src={{cinejoyFeaturedGuests[0].img}} >
                        </div>
                        <div style="width: 10%;"></div>
                        <div style="margin-top: 20px;" *ngIf="!isWatchStarted && cinejoyFeaturedGuests">
                            <img class="profile-thumb profile-thumb-two" src={{cinejoyFeaturedGuests[1].img}} >
                        </div>
                    </div>

                    <div class="row justify-content-center" style="width: 100%; margin-left: -16.5%; font-family: 'Verdana'; font-size: 15px;">
                        <div class="col-md-6 col-xl-3 col-xs-3 col-sm-6  text-center btn-size">
                            <button class="btn btn1 watch-btn btn-align" *ngIf="!isWatchStarted" (click)="startWatch()" type="button">
                                {{timeDiff > 0 ? timeDifferString : 'WATCH RED CARPET NOW'}}
                            </button>
                        </div>
                        <div class="col-md-6 col-xl-3 col-xs-3 col-sm-6 text-center">
                            <button class="btn btn1 watch-btn btn-align1" *ngIf="!isWatchStarted" (click)="openModal()"  type="button">PHOTOBOOTH</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="red-carpet-div" *ngIf="isWatchStarted">
            <div fxFlex=100 fxLayoutAlign="center center">
                <iframe fxFill fxFlex=100 fxFlex.md=100 class="iframeTrailer"  [src]="redCarpetVideo"
                    frameborder="0" webkitallowfullscreen
                    mozallowfullscreen allowfullscreen>
                </iframe>
            </div>
        </div>
    </div>

    <div fxLayout="row">
        <div  [ngStyle]="{'bottom':'5px','position':'absolute','left':'40%'}"  fxHide.sm fxHide.xs fxShow.md fxShow.xl fxShow.lt-md>
            <button class="btn btn-block btn1 watch-btn mt-2"  *ngIf="isWatchStarted && photoboothButton" (click)="openModal()"  type="button">PHOTOBOOTH</button>
        </div>
        <div  [ngStyle]="{'bottom':'19%','position':'absolute','left':'27%'}"  fxShow.xs fxHide.sm  fxHide.lg fxHide.md fxHide.lt fxHide.lt-lg fxHide.gt-lg>
            <button class="btn btn-lg  btn-block center  btn-visible"  *ngIf="isWatchStarted && photoboothButton" (click)="openModal()" >PHOTOBOOTH</button>
        </div>

        <div [ngClass]="[(isWatchStarted && photoboothButton) ? 'emojis-container-after' : 'emojis-container', (isIOSDeviceVariable) ? 'emojis-container-ios' : '']" style="position: absolute;">
            <app-emoji-chart (parentFunction) = "parentFunction($event)" [id]= "event_id"  [page]="page"></app-emoji-chart>
        </div>
        <!--Red-Carpet Chat Component-->
        <div [ngClass]="[(isWatchStarted && photoboothButton) ? 'card-buttons-after' : 'card-buttons', (isIOSDeviceVariable) ? 'card-buttons-ios' : '']" class="card" style="position: absolute;border: 0;">
            <app-red-carpet-chatbar [eventId]="event_id" [userId]= "userId" [page]="page"></app-red-carpet-chatbar>
        </div>
    </div>
</div>
<!-----------------------------------Photobooth Modal------------------------------------------->

                                <!--Information Model-->
<div class="modal" id="myModal5" style="padding-top: 0px !important;font-family: 'Verdana, sans-serif'; font-size: 15px; line-height: 22.5px;"  aria-hidden="true">
    <div class="modal-dialog" >
        <div class="modal-content modal-content-myModal2" style="background: #171717; width: 100%;">
            <!-- <div class="modal-header" style="color:white">
                <h2  class="text-center">Instructions</h2>
                <button class="btn float-right" style="background:transparent; border:none;color: white;">X</button>
            </div> -->
            <div class="modal-body model5-mobile-height" style="padding-top: 0px !important;overflow: auto;">
                <button class="btn float-right" style="background:transparent; border:none;color: white;position:absolute;right:10px;top:5px;" (click)="hideModal()">X</button>
                <h2  class="text-center modal-title">Instructions</h2>
                <hr style="width: 100%;"/>
                <div class="row form-group mt-3">
                    <div class="col-md-4 text-center">
                        <img src="assets/images/Photobooth/capture-btn.PNG">
                    </div>
                    <div class="col-md-8 " >
                        <p class="text-white">CAPTURE your image by clicking this button.</p>
                    </div>
                </div>
                <div class="separator">
                    OR
                </div>
                <div class="row form-group">
                    <div class="col-md-4 text-center">
                        <img src="assets/images/Photobooth/upload-btn.PNG">
                    </div>
                    <div class="col-md-8">
                        <p class="text-white">UPLOAD your image by clicking this button.</p>
                    </div>
                </div>
                <div class="separator">
                    THEN
                </div>
                <div class="row form-group">
                    <div class="col-md-4 text-center">
                        <img src="assets/images/Photobooth/download-btn.PNG">
                    </div>
                    <div class="col-md-8">
                        <p class="text-white">DOWNLOAD the picture and share via your social media.</p>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-md-12">
                        <img src="assets/images/Photobooth/text-icon.PNG" width="100%" style="border: 1px solid #fff">
                    </div>
                </div>

                <div class="row form-group mt-1" >
                    <div class="col-md-12 float-left">
                        <p class="text-white">ENTER your name here.</p>
                    </div>
                </div>
                <div class="text-center">
                <button class="" (click)="openPhotoboothModal()" id="myModal5-close" style="padding: 2% 8%;border: none;border-radius: 5px;margin: 5% 0 5% 0;cursor: pointer;-webkit-appearance: none !important;background-color: #fff !important;">
                    Begin
                </button>
                </div>
            </div>
        </div>
    </div>
</div>

<!--=================================================================================-->

<div class="modal" id="myModal2" style="background: rgba(0, 0, 0, 0.8); padding-right: 0px !important; display: block;">
    <div class="modal-dialog modal-md model2-desktop" style="width: 100% !important;max-width: 100% !important;position: inherit !important;top: 0 !important;left: 0 !important;">
        <div class="modal-content modal-content-myModal2 mac-resolution" style="padding-bottom: 5rem !important;background: #171717;">

            <div class="modal-body modal3MobilePadding " style="padding-top: 0px !important;overflow: auto;padding-bottom: 25px !important; max-height: 100vh !important;overflow-y: auto;-webkit-overflow-scrolling: touch;">
               <div class="container1">
                <button class="btn float-right" style="color: white;position:absolute;right:3px;top:0px;font-size:20px;font-weight: 600;background-color: black;width: 1rem;height: 1rem;padding: 0px;" (click)="hideModal()">X</button>
                <!-- The buttons to control the stream -->
                <div class="container1" id="wrapper" style="background-color: #000 !important;height: 70% !important;width: 100%;overflow-y: hide;">
                    <div class="row text-center backgroud-img" >
                        <img class="img-fluid mt-1 mb-2" src="assets/images/Photobooth/CinejoyBg2.PNG" width="100%">

                        <div class="offset-sm-1 col-sm-5 offset-md-1 col-md-5 mobile-col" style="padding: 0 15px !important">
                            <div class="card" style="border-radius: 0 !important;background: transparent;">
                                <div class="container2" id="container2">
                                    <img class="img-fluid left-card-img desktop-border img-box-lt" crossorigin="anonymous" src={{featureGuestImage}}  >
                                </div>

                            </div>
                            <h6 class="text-center mobile-description ng-binding" style="background: #171717;color: yellow;padding: 2% 0;font-weight: 600;margin-top:2.3vw;border-radius: 5px;
                            display: flex;
                            justify-content: center;
                            align-items: center;">{{ featuredGuestName }} IN {{featuredGuestMovie}}</h6>
                        </div>
                        <div class="col-sm-5 col-md-5 mobile-col" style="padding: 0 15px !important">
                            <div class="card" style="border-radius: 0 !important;background: transparent;">
                                <div class="container2">
                                    <canvas class="img-fluid bg-white right-card-img desktop-border img-box-rt" height="450" #canvas id="capture" ></canvas>
                                </div>
                            </div>


                            <h6 class="mobile-description mobile-description-right desktop-description2">
                                <input class="mobile-description-text-mobile" placeholder = {{fullname}} #input [value]="input.value.toUpperCase()" style="width: 100% !important;border: none !important;text-align: center;color: yellow !important;font-family: inherit !important;text-transform: uppercase;" type="text">
                            </h6>
                        </div>

                        <img class="img-fluid" style="margin-bottom: -1% !important;" src="assets/images/Photobooth/CinejoyBg2.PNG" width="100%">
                    </div>
                </div>
                <div class="container1 mobile-buttons2" style="background-color: #000 !important;height: auto !important;padding-top: 1rem;">
                    <div class="offset-md-6 col-md-5">
                        <div class="row text-center" style="background-color: #000;margin-top: 0px !important;">
                            <div class="col-sm-4 col-md-4 col-4-mobile" style="padding: 0 15px !important;">
                                <button class="btn btn-block" (click)="openModal3()"  id="btn-start" style="border: 2px solid gold;background-color: gold;height: 48px;cursor: pointer;" title="CAPTURE your image by clicking this button." type="button">
                                    <span><i class="fa fa-camera p-2 text-white" style="font-size: 20px;"></i></span>
                                </button>
                            </div>
                            <div class="col-sm-4 col-4-mobile" style="padding: 0 15px !important;">
                                <div class="fileUpload" style="border: 2px solid gold;background-color: gold;height: 48px;cursor: pointer;border-radius: .25rem;">
                                    <!-- <input type="file" class="upload" id=finput onchange="upload()" multiple="false" accept="image/*" title="You Can Upload Your Image From Here."/> -->
                                    <input accept="image/*"  class="upload"  id="file-input"  (change)="fileChangeEvent($event)" multiple="false" title="UPLOAD your image by clicking this button." type="file">
                                    <!-- <input type="file" (change)="preview($event)" class="upload"  title="UPLOAD your image by clicking this button."  /> -->
                                    <span><i class="fa fa-upload p-3
                                         text-white" style="font-size: 20px;"></i></span>
                                </div>
                            </div>

                            <div class="col-sm-4 col-md-4 col-4-mobile" style="padding: 0 15px !important;">
                                <button class="
                                btn btn-block" (click)="takeshot()" style="border: 2px solid #de1b36;background-color: #de1b36;height: 40px;cursor: pointer;height: 48px;" title="DOWNLOAD the picture and share via your social media">
                                    <i class="fa fa-download p-2 text-white" style="font-size: 20px;"></i>
                                </button>
                            </div>
                        </div>
                    </div>
               </div>
              </div>
            </div>

                <div id="my-node"></div>
                <div class="button-group hide">
                    <button class="button" id="btn-stop" style="display: none;" type="button"></button>
                </div>
        </div>
    </div>
</div>

<!--Capture Modal-->
<div class="modal fade show" id="myModal3" style="padding-left: 0 !important;">
    <div class="modal-dialog modal-md" style="position: relative !important;width: auto !important;top: 0 !important;left: 0 !important;">
        <div class="modal-content" style="width: 100% !important; background: #171717;">

            <!-- Modal Header -->
            <div class="col-md-12 text-center pt-2">
                <button class="btn float-right" style="background:transparent; border:none;color: white;position:absolute;right:10px;top:5px;font-size: 18px;" (click)="hideCaptureModal()">X</button>
                <h2 class="text-center" style="left: auto !important;color:white">Capture Image</h2>
                <hr style="width: 100% !important;">
            </div>

            <!-- Modal body -->
            <div class="modal-body" style="padding-top: 0% !important;">
                <video class="img-fluid" id="video" #video autoplays playsinline></video>
            </div>

            <!-- Modal footer -->
            <div class="col-md-12 text-center mb-2" style="padding: 0 15px !important;">
                <button (click)="capture()" class="button btn-block btnClosePopup2" id="btn-capture" style="border: 2px solid #de1b36;background-color: #de1b36;" type="button">
                    <i class="fa fa-camera p-2 text-white" style="font-size: 24px;"></i><font class="text-white pl-2" style="font-size: 24px;">Capture</font>
                </button>
            </div>

        </div>
    </div>
</div>
<div class="modal" id="myModal4" style="padding-left: 16px; display: block;">
    <div class="modal-dialog modal-md" style="position: relative !important;width: auto !important;top: 0 !important;left: 0 !important;">
        <div class="modal-content" style="width: 100% !important;background: #000;">

            <div class="col-md-12 text-center pt-2">
                <button class="btn float-right" style="background:transparent; border:none;color: white;position:absolute;right:10px;top:5px;font-size: 18px;" (click)="hideUploadImgModal()">X</button>
                <h2 class="text-center" style="left: auto !important;color: #fff">Upload Image</h2>
                <hr style="width: 100% !important;color:#fff">
            </div>

            <!-- Modal body -->
            <div class="modal-body text-center" style="padding-top: 0% !important;">

                <main class="page">
                    <!-- input file -->

                    <!-- leftbox -->
                    <div class="box-2">
                      <!-- <div class="result"></div> -->
                      <image-cropper
                         #imageCropper
                        style="max-width: 100%;"
                        [imageChangedEvent]="imageChangedEvent"
                        [maintainAspectRatio]="true"
                        [aspectRatio]="4/ 4"
                        [autoCrop]="false"
                        outputType="both"
                        (imageCropped)="imageCropped($event)"
                       ></image-cropper>
                    </div>

                    <!--rightbox-->
                    <div class="box-2" *ngIf="img_result">
                        <img [src]="croppedImage" class="cropped" id="result_image" alt="" style="max-width:100% ;" />
                    </div>


                    <!-- input file -->
                    <div class="box">
                        <div class="options show">
                            <!-- <label> Width</label> -->
                            <input class="img-w" max="1200" min="100" style="display: none !important;" type="number" value="300">
                        </div>
                        <!-- save btn -->
                        <button class="btn"   (click)="previewCroppedImage()" *ngIf="previewImagepic">Preview</button>
                        <!-- download btn -->
                        <button class="btn btnClosePopup" href="" id="saveBtnShow" style="color: rgb(0, 0, 0) !important;" (click)="save()" *ngIf="saveCroppedImage">Save</button>

                    </div>
                </main>
                <p id="demo"></p>
            </div>

            <!-- Modal footer -->
            <div class="col-md-12 text-center mb-2" style="padding: 0 15px !important;">
            </div>

        </div>
    </div>
</div>